function getConfig(name, defaultValue = null) {
  if (window.ENV !== undefined) {
    return window.ENV[name] || defaultValue;
  }

  return import.meta.env[name] || defaultValue;
}

export function getBackendUrl() {
  return (
    getConfig("REACT_APP_BACKEND_URL") ||
    getConfig("VITE_BACKEND_URL") ||
    "http://localhost:8080/"
  );
}

export function getHoursCloseTicketsAuto() {
  return getConfig("VITE_HOURS_CLOSE_TICKETS_AUTO");
}
